var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-420 -85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,1A5.5,5.5,0,1,0,12,6.5,5.506,5.506,0,0,0,6.5,1m0-1A6.5,6.5,0,1,1,0,6.5,6.5,6.5,0,0,1,6.5,0Z",
    transform: "translate(420 85)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.393,2.89a.5.5,0,0,1-.353-.146L-.353.354a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0l2.393,2.39a.5.5,0,0,1-.353.854Z",
    transform: "translate(423.498 91.305)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.9a.5.5,0,0,1-.353-.146.5.5,0,0,1,0-.707l3.392-3.4a.5.5,0,0,1,.707,0,.5.5,0,0,1,0,.707L.354,3.752A.5.5,0,0,1,0,3.9Z",
    transform: "translate(426.098 90.102)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHired);
export default __webpack_public_path__ + "static/media/hired.1079040b3b13b491ed218e813cd387a2.svg";
export { ForwardRef as ReactComponent };